import { IconButton, styled } from "@mui/material";

import { dontForwardProps } from "@/lib/styled";

export const StyledPagination = styled("div")(
  ({ theme }) => `
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacing(3)};

  button {
    border-radius: 50%;
    border: 2px solid ${theme.palette.primary.main};
    width: 48px;
    height: 48px;
    cursor: pointer;
    margin: 0 5px;

    &:hover {
      background: ${theme.palette.primary.main};
      color: ${theme.palette.common.white};

      &:not(.Mui-disabled) svg {
        fill: ${theme.palette.common.white};
      }
    }

    &:not(.Mui-disabled) svg {
      fill: ${theme.palette.primary.main};
    }
  }
`,
);

export const NumericalItems = styled(IconButton, {
  shouldForwardProp: dontForwardProps("active"),
})<{ active: boolean }>(
  ({ theme, active }) => `
  background: ${active ? theme.palette.primary.main : "transparent"};
  color: ${active ? theme.palette.common.white : theme.palette.primary.main};
  display: ${active ? "block" : "none"};
  font-size: 18px;

  @media (width >= 640px) {
    display: block;
  }
`,
);
